import * as z from "zod/v4";

export const ConnectionSchema = z.object({
  identifier: z.string(),
  name: z.string(),
  connectionType: z.string(),
});

export const IntegrationSchema = z.object({
  identifier: z.string(),
  name: z.string(),
  connections: z.record(z.string(), ConnectionSchema),
});

export type Connection = z.infer<typeof ConnectionSchema>;
export type Integration = z.infer<typeof IntegrationSchema>;
